export default __webpack_public_path__ + "media/images/loop-f8c50ea47b7cbfb5b5fe53e66ac2ef63.png";